import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/news/delay_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-67b9a504"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recommend-header" }
const _hoisted_2 = { class: "recommend-title" }
const _hoisted_3 = {
  key: 0,
  class: "recommend-loading"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "recommend-card__content" }
const _hoisted_6 = { class: "recommend-card__title" }
const _hoisted_7 = ["onDblclick"]
const _hoisted_8 = { class: "stock-badge" }
const _hoisted_9 = { class: "stock-name" }
const _hoisted_10 = {
  key: 0,
  src: _imports_0,
  class: "recommend-delay-icon",
  alt: "延时"
}
const _hoisted_11 = { class: "recommend-card__footer" }
const _hoisted_12 = { class: "recommend-card__source" }
const _hoisted_13 = {
  key: 0,
  class: "recommend-card__time"
}
const _hoisted_14 = {
  key: 0,
  class: "recommend-card__thumb"
}
const _hoisted_15 = ["src"]

import { watch, onUnmounted } from 'vue'
import { getStockClass } from '@/utils/stock'
import { reportBuriedPoint } from '@/utils/news'
import ws from '@/websocket/index'
import { resolveMarket, getFDMarketTag ,getFDMarketRegion} from '@/websocket/quotationWebsocket'
// ─── 类型定义 ─────────────────────────────────────────────────────────────────
export interface RecommendImage {
  url: string
  width: number
  height: number
  id: number
  newsId: number
}

export interface RecommendStockInfo {
  ei: number | null
  exchange: string
  fluctuation_range: number
  isSelfSelected: number | null
  lastPrice: number | null
  market: string
  name: string
  newsId: number
  relevance: string | null
  stock_list_status: string
  stock_list_status_name: string
  symbol: string
}

export interface RecommendItem {
  id: number
  decryptId: string
  title: string
  abstracts: string
  catId: number
  createTimeFormat: string
  createdTime: number
  source: string
  image: RecommendImage | null
  stockInfo: RecommendStockInfo | null
  stockInfoList: RecommendStockInfo[]
}

// ─── Props & Emits ────────────────────────────────────────────────────────────

export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendList',
  props: {
    list: null,
    isDark: { type: Boolean },
    loading: { type: Boolean },
    lang: null,
    preferGreenUp: null,
    hkDelay: { type: Boolean },
    usDelay: { type: Boolean }
  },
  emits: ["select-news", "stock-dblclick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select-news', id: number, title: string, decryptId: string): void
  (e: 'stock-dblclick', fullCode: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  list: RecommendItem[]
  isDark: boolean
  loading: boolean
  lang?: string        // 语言标识，'zh-Hant' 时启用繁体转换
  preferGreenUp?: string  // 涨跌色偏好，'1' = 绿涨红跌
  hkDelay?: boolean    // 港股是否延时
  usDelay?: boolean    // 美股是否延时
}





// ─── 繁体支持 ─────────────────────────────────────────────────────────────────
function tran(text: string): string {
  if (!text) return text
  if (props.lang === 'zh-Hant') return (text as any).tran() 
  return text
}

// ─── 工具函数 ─────────────────────────────────────────────────────────────────

/**
 * 优先返回 stockInfoList[0]，其次 stockInfo，否则 null
 */
function getFirstStock(item: RecommendItem): RecommendStockInfo | null {
  if(item.stockInfoList == null) return null
  if (item.stockInfoList && item.stockInfoList.length > 0) {
    return item.stockInfoList[0]
  }
  return item.stockInfo ?? null
}

/**
 * 返回缩略图 URL，无图时返回空字符串
 */
function getThumb(item: RecommendItem): string {
  return item.image?.url ?? ''
}

/**
 * 格式化涨跌幅：正数加 + 前缀，保留2位小数，加 % 后缀
 * null/undefined 时显示 0.00%
 */
function formatPct(val: number | undefined | null): string {
  if (val === undefined || val === null) return '0.00%'
  const sign = val > 0 ? '+' : ''
  return `${sign}${val.toFixed(2)}%`
}

/**
 * 根据涨跌幅返回 CSS 类名
 */
function stockClass(val: number | undefined | null): string {
  return getStockClass(val, props.preferGreenUp)
}

// ─── 行情订阅 ─────────────────────────────────────────────────────────────────
const RECOMMEND_LIST_KEY = 'recommendlist_stocks'

function resolveMarketLocal(market: string): string {
  return resolveMarket(market, props.hkDelay ?? false, props.usDelay ?? false)
}

// 判断股票是否显示延时图标
function isDelayedStock(s: { market?: string; exchange?: string }): boolean {
  const market = (s.market || s.exchange || '').toUpperCase()
  if (!market) return false
  const region = getFDMarketRegion(market)
  if (region === 'HK' && props.hkDelay) return true
  if (region === 'US' && props.usDelay) return true
  return false
}

function subscribeStocks(items: RecommendItem[]) {
  ws.websocket.safeUnsubscribeList(RECOMMEND_LIST_KEY)

  const seen = new Set<string>()
  const stocks: Array<{ symbol: string; market: string }> = []

  items.forEach(item => {
    // 优先 stockInfoList[0]，其次 stockInfo
    const s = (item.stockInfoList?.length ? item.stockInfoList[0] : null) ?? item.stockInfo
    if (!s?.symbol || !s?.market) return
    const resolvedMarket = resolveMarketLocal(s.market)
    const k = `${s.symbol}_${resolvedMarket}`
    if (!seen.has(k)) {
      seen.add(k)
      stocks.push({ symbol: s.symbol, market: resolvedMarket })
    }
  })

  if (!stocks.length) return
  ws.websocket.safeSubscribeList(RECOMMEND_LIST_KEY, stocks)
}

function onHqUpdate(msg: any) {
  const dynaData: any[] = msg?.QuoteData?.DynaData || []
  dynaData.forEach((d: any) => {
    if (d.UpdownRate === undefined) return
    props.list.forEach(item => {
      const s = (item.stockInfoList?.length ? item.stockInfoList[0] : null) ?? item.stockInfo
      if (!s) return
      if (s.symbol === d.InstrumentID) {
        s.fluctuation_range = parseFloat((d.UpdownRate * 100).toFixed(2))
        if (d.LastPrice !== undefined) s.lastPrice = d.LastPrice
      }
    })
  })
}

// list 变化时重新订阅
watch(() => props.list, (newList) => {
  if (newList?.length) {
    subscribeStocks(newList)
  } else {
    ws.websocket.safeUnsubscribeList(RECOMMEND_LIST_KEY)
  }
}, { immediate: true })

ws.websocket.on('onHQLIST', onHqUpdate)

onUnmounted(() => {
  ws.websocket.removeListener('onHQLIST', onHqUpdate)
  ws.websocket.safeUnsubscribeList(RECOMMEND_LIST_KEY)
})

// ─── 事件处理 ─────────────────────────────────────────────────────────────────

function onCardClick(item: RecommendItem) {

  if (item.id && Number.isInteger(item.id)) {
    emit('select-news', item.id, item.title || '', item.decryptId || '')
  }
}

/** 与 NewsDetail.onStockCardClick 一致，由父组件 checkHsAndJump 处理跳转 */
function onStockCardClick(s: RecommendStockInfo) {
  if (!s.market) return
  const fullCode = `${s.symbol}.${s.market}`
  emit('stock-dblclick', fullCode)
}

return (_ctx: any,_cache: any) => {
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (__props.list.length || __props.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["recommend-section", __props.isDark ? 'dark' : 'light'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(tran('推荐资讯')), 1)
        ]),
        (__props.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(tran('加载中')) + "…", 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "recommend-card",
            onClick: ($event: any) => (onCardClick(item))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(tran(item.title)), 1),
              (getFirstStock(item))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "recommend-card__stock",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                    onDblclick: _withModifiers(($event: any) => (onStockCardClick(getFirstStock(item)!)), ["stop"])
                  }, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(getFDMarketTag)(getFirstStock(item)!.market || getFirstStock(item)!.exchange)), 1),
                    _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createTextVNode(_toDisplayString(tran(getFirstStock(item)!.name)), 1)
                    ])), [
                      [_directive_widthoverflowtitle, tran(getFirstStock(item)!.name)]
                    ]),
                    (isDelayedStock(getFirstStock(item)!))
                      ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(["stock-pct", stockClass(getFirstStock(item)!.fluctuation_range)])
                    }, _toDisplayString(formatPct(getFirstStock(item)!.fluctuation_range)), 3)
                  ], 40, _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(tran(item.source)), 1),
                (item.createTimeFormat)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.createTimeFormat), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (getThumb(item))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: getThumb(item),
                    alt: ""
                  }, null, 8, _hoisted_15)
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
}
}

})